<template>
  <div class="item-wrapper">
    <input type="checkbox" class="item-wrapper__checkbox" v-if="item.id && isMassEdit" v-model="isChecked" />
    <router-link class="items-container__item item" :class="{ 'add-new-item': item.isNewRoute }"
      :to="item.isNewRoute ? { name: 'add-parking' } : { name: 'parking', params: { id: item.id } }">
      <div class="item__row" v-if="!item.isNewRoute">
        <span class="item__title">{{ item.vehicleReg }}</span>
        <span title="comment">{{ item.comment }}</span>
      </div>
      <div class="item__statusbar" v-if="!item.isNewRoute">
        <span class="filling"
          v-bind:style="{ 'background-color': getStatusBarColor(item.startTime, item.endTime) }"></span>
      </div>

      <div class="item__row item__subtitle" v-if="!item.isNewRoute">
        <span>
          <span>{{ item.startTime | moment }} -</span>
          <span v-if="item.endTime">{{ item.endTime | moment }}</span>
        </span>
        <span :style="{'color': '#000'}">{{ getTotalParkingTime(item) }}</span>
        <span>
          <span title="price" v-if="item.price">{{ item.price.toFixed(2) }} €</span>
        </span>
      </div>
      <div class="item__row item__title" v-if="item.isNewRoute">
        <span>{{ item.name }}</span>
      </div>
    </router-link>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  props: {
    item: Object,
    isMassEdit: Boolean,
    onClickCheckbox: Function,
    checked: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    getStatusBarColor(startTime, endTime) {
      const currentTime = moment();
      if (currentTime.isBefore(moment(moment(startTime).toDate()))
        && (endTime == null || currentTime.isBefore(moment(moment(endTime).toDate())))) {
        return 'aqua';
      }
      if (currentTime.isAfter(moment(moment(endTime).toDate()))) {
        return '#D8D8D8';
      }
      return '#E94F0A';
    },
    formatPeriod(minutes, unit) {
      const minutes_in_hour = 60;
      const minutes_in_day = 24 * 60;

      if (unit === 'month') {
        return `${minutes} ${this.$tc('pricingrules.month', minutes)}`;
      }
      let min = minutes;
      let days = Math.floor(min / minutes_in_day);
      min -= days * minutes_in_day;
      let hours = Math.floor(min / minutes_in_hour);
      min -= hours * minutes_in_hour;
      if (days === 1) {
        days = `${days} ${this.$tc('pricingrules.day', 1)} `;
      } else if (days > 1) {
        days = `${days} ${this.$tc('pricingrules.day', 2)} `;
      } else {
        days = '';
      }
      if (hours) {
        hours = `${hours} ${this.$t('pricingrules.hour')} `;
      } else {
        hours = '';
      }
      if (min) {
        min = `${min} ${this.$t('pricingrules.minute')} `;
      } else {
        min = '';
      }
      return (days + hours + min).trim();
    },
    getTotalParkingTime(item) {
      const start = moment(item.startTime);
      const end = moment(item.endTime);
      if (end.isBefore(moment(start.toDate()))) {
        return '-';
      }
      return this.formatPeriod(Math.floor(end.diff(start) / 60000));
    },
  },
  filters: {
    moment(date) {
      return moment(date).format('DD.MM.YYYY HH:mm');
    },
  },
  data() {
    return {
      isChecked: this.checked,
    };
  },
  watch: {
    isChecked() {
      this.onClickCheckbox(this.item.id, this.isChecked);
    },
  },
  updated() {
    this.isChecked = this.checked;
  },
};
</script>



// WEBPACK FOOTER //
// src/components/parkings/ListItemTemplate.vue